import { AxiosResponse } from 'axios';
import qs from 'qs';
import { trackPromise } from 'react-promise-tracker';
import api from '../../../../../utils/API';
import { getValidData } from '../../../RevisaoPrecos/utils';

export type GetNegociacoesItemProps = {
  id: string;
} & Partial<{
  name: string;
  totalProducts: number;
  supplierId: string;
  supplierName: string;
  startDate: string;
  endDate: string | null;
  lastEditedDate: string;
  owner: string;
  status: 'ONGOING' | 'CLOSED';
  enableFinalDate?: boolean | null;
  stores: string[];
  clusters: string[];
  visionSaved: 'STORE' | 'CLUSTER' | 'NETWORK';
}>;

export type GetNegociacoesDataProps = {
  content: GetNegociacoesItemProps[];
  totalElements: number;
};

export type NegotiationSavedFiltersPayload = {
  product: string[];
  store: string[];
  cluster: string[];
  supplier: string[];
  owner: string[];
  status: '' | 'ONGOING' | 'CLOSED';
  visionSaved: string[];
};

export type GetNegociacoesSalvasParams = {
  search?: string;
  sort: string;
  size: number;
  page: number;
  filters: NegotiationSavedFiltersPayload;
};

export type NegotiationOwnerOption = {
  label: string;
  value: string;
};

export async function GETNegociacoesSalvas(params: GetNegociacoesSalvasParams): Promise<GetNegociacoesDataProps> {
  const { filters, ...queryParams } = params;

  return trackPromise<AxiosResponse<GetNegociacoesDataProps>>(
    api({
      url: `${process.env.REACT_APP_IPA_URL}/negotiations/all`,
      method: 'POST',
      expectToken: true,
      params: getValidData(queryParams),
      data: getValidData(filters),
      paramsSerializer(params: GetNegociacoesDataProps) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    }),
    'negociacoes/salvas/get-negociacoes',
  ).then(res => res.data);
}

export async function GETNegociacoesOwners(search?: string): Promise<NegotiationOwnerOption[]> {
  return trackPromise<AxiosResponse<string[]>>(
    api({
      url: `${process.env.REACT_APP_IPA_URL}/negotiations/owner`,
      method: 'GET',
      expectToken: true,
      params: getValidData({ search }),
    }),
    'negociacoes/salvas/get-negociacoes-owners',
  ).then(res =>
    (res.data ?? []).map(item => ({
      label: item,
      value: item,
    })),
  );
}
